import { omdApi } from 'bus/api';

import { ClaimsItem, RoleCreate, RoleItem } from './types';

const roleApi = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoleList: builder.query<{ data: RoleItem[] }, void>({
      query: () => ({
        url: '/v1/Role',
      }),
    }),

    getRoleDetail: builder.query<RoleItem, { id: number | string }>({
      query: ({ id }) => ({
        url: `/v1/Role/${id}`,
      }),
    }),

    getRoleClaims: builder.query<ClaimsItem[], void>({
      query: () => ({
        url: '/v1/Role/claims',
      }),
    }),

    createRole: builder.mutation<void, Omit<RoleCreate, 'id'>>({
      query: (data) => ({
        url: '/v1/Role',
        method: 'POST',
        body: data,
      }),
    }),

    editRole: builder.mutation<void, RoleCreate>({
      query: (data) => ({
        url: `/v1/Role/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),

    deleteRole: builder.mutation<void, { id: number | string }>({
      query: ({ id }) => ({
        url: `/v1/Role/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetRoleListQuery,
  useLazyGetRoleListQuery,
  useGetRoleDetailQuery,
  useLazyGetRoleDetailQuery,
  useGetRoleClaimsQuery,
  useLazyGetRoleClaimsQuery,
  useCreateRoleMutation,
  useEditRoleMutation,
  useDeleteRoleMutation,
} = roleApi;
